import { init } from "ityped";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import resume from "../img/shikha_pic.jpg";
import PrimaryButton from "./PrimaryButton";
import "../App.css"
function ImageSection() {
  const infoo = useRef();
  useEffect(() => {
    init(infoo.current, {
      showCursor: false,
      backSpeed:  100,
      startDelay: 500,
      backDelay:800,
      strings: ["Shikha Tiwari","An aspiring Web Developer", "A Problem Solver","A food Lover"],
    });
  },[])
  return (
    <ImageSectionStyled>
      <div className="left-content">
        <div className="btn">
        <img src={resume} alt="" />
        </div>
      </div>
      <div className="right-content">
        <h4>
          I am <span ref={infoo}></span>
        </h4>
        <p className="paragraph">
          An aspiring Web developer. Proficient in React, Javascript. Attentive, dynamic, and creative software developer specialized in MERN stack.
Eager to support the dev team with top-notch skills at a high-volume company.
Seeks to use first-class production design and process skills to push forward
overall customer experience.
        </p>
        <div className="about-info"></div>
        <PrimaryButton title={"Download Resume"} />
      </div>
    </ImageSectionStyled>
  );
}



const ImageSectionStyled = styled.div`
  margin-top: 5rem;
  display: flex;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    .left-content {
      margin-bottom: 2rem;
      border-radius:10px;
    }
  }
  .left-content {
    width: 60%;
    border-radius:10px;
    img {
      width: 100%;
      border-radius:10px;
      object-fit: cover;
    }
  }
  .right-content {
    width: 100%;
    h4 {
      font-size: 1rem;
      color: var(--white-color);
      span {
        font-size: 1.5rem;
        @media screen and (max-width: 512px){
          font-size:0.9rem;
        }
      }

     
    }
    .paragraph {
      padding: 1rem 0;
      font-size:17px;
    }
    .about-info {
      display: flex;
      padding-bottom: 1.4rem;
      .info-title {
        padding-right: 3rem;
        p {
          font-weight: 600;
        }
      }
      .info-title,
      .info {
        p {
          padding: 0.3rem 0;
        }
      }
    }
  }
`;
export default ImageSection;
